(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _video = require("./parts/video.js");
var _nav = require("./parts/nav.js");
// import {getInsights} from "./parts/getinsights.js";
// import {getEvents} from "./parts/getevents.js";
window.addEventListener("load", function (event) {
  (0, _nav.nav)();
  (0, _video.kiVideo)();
  // getInsights();
  // getEvents();
});

},{"./parts/nav.js":2,"./parts/video.js":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nav = nav;
function nav() {
  function doLogo() {
    var nav = this.document.getElementById("main-nav-container");
    // var navLogo = this.document.querySelector("#main-nav-logo");
    var navIcon = this.document.getElementById("main-nav-btn");
    if (nav) {
      if (window.scrollY > 20) {
        nav.classList.add("scrolled");
        navIcon.classList.add("scrolled");
        // navLogo.src = logoData.reverseLogo;
      } else {
        nav.classList.remove("scrolled");
        navIcon.classList.remove("scrolled");
        // navLogo.src = logoData.mainLogo;
      }
    }
  }

  var skip = document.getElementById("skip-nav");
  if (skip) {
    skip.addEventListener("click", function (event) {
      var element = document.getElementById("main-content");
      console.log(element);
      if (element) {
        element.focus();
        var offsetPosition = element.offsetTop - 200;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  }
  window.addEventListener("scroll", doLogo);
  function slideDown(element) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
    element.style.height = "0px";
    element.style.overflow = "hidden";
    element.style.display = "block";
    var targetHeight = element.scrollHeight + "px";
    element.style.transition = "height " + duration + "ms ease-in-out";
    element.style.height = targetHeight;
    // Reset height after transition to allow for flexible content
    setTimeout(function () {
      element.style.height = "";
      element.style.overflow = "";
      element.style.transition = "";
    }, duration);
  }
  function slideUp(element) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
    element.style.height = element.offsetHeight + "px";
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + "ms";
    element.style.boxSizing = "border-box";
    element.offsetHeight; // Trigger reflow to apply the transition
    element.style.overflow = "hidden";
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    window.setTimeout(function () {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("padding-top");
      element.style.removeProperty("padding-bottom");
      element.style.removeProperty("margin-top");
      element.style.removeProperty("margin-bottom");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition-duration");
      element.style.removeProperty("transition-property");
    }, duration);
  }
  document.querySelectorAll(".menu-open").forEach(function (button) {
    button.setAttribute("showing", "false");
    button.addEventListener("click", function () {
      var showing = this.getAttribute("showing");
      if (showing === "false") {
        this.setAttribute("showing", "true");
      } else {
        this.setAttribute("showing", "false");
      }
      var menuItem = this.getAttribute("menuitem");
      var submenuContainer = document.getElementById("menu-item-" + menuItem);
      var submenu = submenuContainer.getElementsByTagName("ul")[0];
      if (submenu) {
        if (this.getAttribute("showing") === "true") {
          slideDown(submenu, 200);
        } else {
          slideUp(submenu, 300);
        }
      }
    });
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kiVideo = kiVideo;
function kiVideo() {
  console.log("START KIVIDEO");
}

},{}]},{},[1]);
